import { Grid, Paper, Typography } from '@mui/material'
import React from 'react'
import { isISODateString } from '../services'
import moment from 'moment'

const Header2 = (props) => {

    const { commonStyle, data: headerData, gridCol = 3, xs = 4, rows = {} } = props
    const { heading = {}, typography = {} } = commonStyle

    const companyName = headerData?.headerData?.companyName ?? "N/A"

    return (
        <>
            <Grid
                container
                component={Paper}
            >
                {
                    headerData?.headerFields?.map((element) => {
                        return (
                            <Grid
                                xs={xs}
                            >
                                <Typography sx={{ ...heading }}>{element?.name}</Typography>
                                <Typography sx={{ ...typography }}>
                                    {
                                        element?.uniqueName === "companyName"
                                            ? companyName
                                            : isISODateString(rows[element?.uniqueName])
                                                ? moment(rows[element?.uniqueName]).format("DD/MM/YYYY")
                                                : rows[element?.uniqueName]

                                                ?? "N/A"
                                    }
                                </Typography>
                            </Grid>
                        )

                    })
                }

            </Grid>
        </>
    )
}

export default Header2
